import React, { useEffect, useState } from 'react';

import { IUser } from '~/src/dash/api/console-api';
import {
  generateDestinationMenuList,
  getInventoryRouteByID,
  IInventoryRoute,
} from '~/src/dash/api/inventory_routes';
import {
  buildNetworkChannelList,
  getNetwork,
  INetwork,
  transformNetworkWrapper,
} from '~/src/dash/api/network';
import { IHttpResponse } from '~/src/dash/api/rest';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { parseLocation } from '~/src/dash/router/routes';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import { IHistoryProps } from '~/src/dash/types/props';

// component handles the api call and generation of menu list for network channels
// on top of the MaterialSearchDropdownMulti
interface IProps extends IHistoryProps {
  onChange: (siteIDs: string[]) => void;
  publisherID: string;
  resourceID: string;
  filterObjectIDs: string[];
  menuTitle: string;
  // default false
  disabled?: boolean;
  // default true
  enableMultiSelect?: boolean;
  resourceType: string;
  userInfo?: IUser;
}

export const LiveDataMultiSelect = function ({
  onChange,
  disabled = false,
  filterObjectIDs = [],
  publisherID,
  menuTitle,
  resourceID,
  enableMultiSelect = true,
  resourceType,
  location,
  userInfo,
}: IProps) {
  const [filterObjectsList, setFilterObjectsList] = useState<IMenuList>({});

  const handleMenuSelectionDone = (values: IMenuList) => {
    const objectIDs = Object.values(values)
      .filter((src: IListItem) => {
        return src.selected;
      })
      .map((src: IListItem) => src.ID);
    onChange(objectIDs);
  };

  useEffect(() => {
    if (resourceType === 'Stream') {
      getNetwork(resourceID, publisherID)
        .then((val: IHttpResponse<INetwork>) => {
          const currentNetwork = transformNetworkWrapper(val.parsedBody);
          setFilterObjectsList(buildNetworkChannelList(currentNetwork, filterObjectIDs, false));
        })
        .catch(() => {
          setFilterObjectsList({});
        });
    } else if (resourceType === 'InventoryRoute') {
      const routeID = parseLocation(location.pathname).inventoryrouteid || '';
      getInventoryRouteByID(publisherID, routeID)
        .then((currentRoute: IInventoryRoute) => {
          const destinationList = generateDestinationMenuList(
            currentRoute.Destinations,
            [],
            true,
            userInfo ? userInfo.Username : '',
          );
          setFilterObjectsList(destinationList);
          // default select all destinations to start
          onChange(Object.values(destinationList).map((destination) => destination.ID));
        })
        .catch(() => {
          setFilterObjectsList({});
        });
    }
  }, [publisherID]);

  return (
    <MaterialSearchDropdownMulti
      getValueFromSearchElement={(src: IListItem) => src.title}
      selectAll={enableMultiSelect}
      menuTitle={menuTitle}
      list={filterObjectsList}
      disabled={disabled}
      onChange={setFilterObjectsList}
      handleMenuAcceptClick={handleMenuSelectionDone}
      isNoneSelectedAllSelected={false}
      helperText={''}
      enableMultiSelect={enableMultiSelect}
      width='400'
      fontSize='14px'
    />
  );
};
